// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RfhF","top":"styles_top__7hOyL"};